import React from 'react';

const renderField = ({ input, label,length, habilitar,type, placeholder,value,meta: { touched, error } }) => (
  <div className="form-group">
    {label ? <label className="control-label">{label}</label>:""}
    
    <textarea 
                className="form-control" 
                rows="2"
                disabled   = { habilitar ? true : false }
                maxLength={length}
                placeholder={placeholder} 
                {...input}></textarea>

      {touched && error && <span className="text-danger">{error}</span>}
 
  </div>
);

export default renderField;
   


// WEBPACK FOOTER //
// ./src/container/renderFieldTextArea.js